import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { LuShieldCheck, LuLock, LuEyeOff, LuArrowRight, LuFingerprint, LuServer } from 'react-icons/lu';
import PublicLayout from './PublicLayout';

export default function CoreInfo() {
  useEffect(() => {
    document.title = 'Dailey OS, Secure Infrastructure';
  }, []);

  return (
    <PublicLayout>
      <section className="lp-hero" style={{ paddingBottom: '1rem' }}>
        <div className="lp-hero-inner">
          <div className="os-badge">
            <LuServer size={18} />
            <span>Dailey OS</span>
          </div>
          <h1 className="lp-h1">
            Built on infrastructure<br />
            <span className="lp-h1-accent">you can trust</span>
          </h1>
          <p className="lp-hero-sub" style={{ maxWidth: 520 }}>
            Photo Harbor runs on Dailey OS, our private cloud platform. Your account, your data, and your photos never leave infrastructure we own and operate.
          </p>
        </div>
      </section>

      <section className="lp-features" style={{ paddingTop: '1.5rem' }}>
        <div className="lp-section-inner">
          <div className="lp-features-grid" style={{ maxWidth: 900, margin: '0 auto' }}>
            <div className="lp-feature-card">
              <div className="lp-feature-icon"><LuLock size={20} /></div>
              <h3>Encrypted credentials</h3>
              <p>Your password is hashed and stored securely. Only you can access your account, we can't read it either.</p>
            </div>
            <div className="lp-feature-card">
              <div className="lp-feature-icon"><LuFingerprint size={20} /></div>
              <h3>Passkey support</h3>
              <p>Sign in with biometrics or hardware keys. Phishing-resistant authentication built in from day one.</p>
            </div>
            <div className="lp-feature-card">
              <div className="lp-feature-icon"><LuShieldCheck size={20} /></div>
              <h3>Single sign-on</h3>
              <p>One secure identity across all Dailey apps. Your credentials stay with the OS and are never shared with individual services.</p>
            </div>
            <div className="lp-feature-card">
              <div className="lp-feature-icon"><LuServer size={20} /></div>
              <h3>Private infrastructure</h3>
              <p>No AWS. No Google Cloud. Your photos are stored on hardware we own in data centers we control.</p>
            </div>
            <div className="lp-feature-card">
              <div className="lp-feature-icon"><LuEyeOff size={20} /></div>
              <h3>Zero data monetization</h3>
              <p>No tracking pixels, no ad networks, no data brokers. We're funded by subscriptions, not surveillance.</p>
            </div>
            <div className="lp-feature-card">
              <div className="lp-feature-icon"><LuArrowRight size={20} /></div>
              <h3>Full data portability</h3>
              <p>Export your entire library anytime in original quality. No lock-in, no exit fees, no degraded exports.</p>
            </div>
          </div>
          <div style={{ textAlign: 'center', marginTop: '2.5rem' }}>
            <Link to="/login" className="lp-btn-primary">
              Back to sign in <LuArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
